import React, { Component } from 'react';
import { Modal, Button, Icon, message } from 'antd';
import FormList from '../../../basicElement/FormList';
import $ from "../../../../common/AjaxRequest";
import API_URL from '../../../../common/url';

class Update extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        list: [],
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    }

    show = (record) => {
        this.setState({
            list: [],
            visible: true,
            isEdit: !!record,
            data: {
                ...(record || {}),
                courtyardArea:record?record.courtyardArea:undefined,
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (option, key, type) => {
        const { data } = this.state;
        if (type === 'searchRetrieve') {
            const { text, value } = option;
            if (key === 'companyName') {
                data.competingCompanyId = value;
                data.companyName = text;
            } else if (key === 'hospitalName') {
                data.hospitalMainId = value;
                data.hospitalName = text;
                data.hospitalId = undefined;
                data.courtyardArea = undefined;
                data.departmentId = undefined;
                data.departmentLocalName = undefined;
                data.piUserId = undefined;
                data.piUserName = undefined;
                this.setState({CourtyardAreaList: []})
                this.queryCourtyardAreaList();
            } else if (key === 'departmentLocalName') {
                data.departmentId = value;
                data.departmentLocalName = text;
                data.piUserId = undefined;
                data.piUserName = undefined;
            } else if (key === 'piUserName') {
                data.piUserId = value;
                data.piUserName = text;
            } 
        } 
        else {
            data[key] = option;
        }
        if(key === 'courtyardArea'){
            data.hospitalId = option.value;
            data.courtyardArea = option.text;
            data.departmentId = undefined;
            data.departmentLocalName = undefined;
        }
        this.setState({ data });
    }

    timer = null;

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { data: { hospitalMainId } } = this.state;
            this.setState({CourtyardAreaList: []})
            if( hospitalMainId !== undefined ){
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.queryHospitalCourtyardAreaList,
                    data: {    
                        hospitalMainId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        const { datas } = res;
                        const { data } = this.state;
                        let { needCourtyardArea } = this.state;
                        needCourtyardArea = false;
                        datas.map(i=>{
                            if (i.courtyardArea) {
                                needCourtyardArea = true;
                            }
                        })
                        data.hospitalId = datas[0].hospitalId;
                        // const needCourtyardArea = datas && datas[0].courtyardArea;
                        this.setState({ needCourtyardArea, data });
                    }
                };
                $.sendRequest(options);
            }
        }, 300);
    }

    getColumns = () => {
        const { isEdit, loading, data, data:{ actualStartSiteAmount, actualRandomAmount },CourtyardAreaList, needCourtyardArea, ids } = this.state;
        const { hospitalMainId, departmentId, hospitalName , hospitalId, courtyardArea } = data;
        // 字段属性配置
        const columns = [{
            name: '公司名称',
            key: 'companyName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'companyName',
                style: { width: 200 },
                placeholder: '输入公司名称检索',
                params: { limit: 20 },
                url: API_URL.competeCompany.queryCompany,
                config: { id: 'competingCompanyId', name: 'companyName', type: 'competeCompany' },
            },
            rules: {
                required: true,
            }
        }]
        columns.push(
        //     {
        //     name: '实际启动总site数',
        //     key: 'actualStartSiteAmount',
        //     type: 'inputNumber',
        //     typeProperty: {
        //         value: actualStartSiteAmount,
        //         style: { width: 200 },
        //         placeholder: '请输入',
        //         precision:0,
        //     },
        //     rules: {
        //         required: false,
        //     }
        // }, {
        //     name: '实际入组总数',
        //     key: 'actualRandomAmount',
        //     type: 'inputNumber',
        //     typeProperty: {
        //         value: actualRandomAmount,
        //         style: { width: 200 },
        //         placeholder: '请输入',
        //         precision:0,
        //     },
        //     rules: {
        //         required: false,
        //     }
        // },  
        {
            name: '中心所在医院',
            key: 'hospitalName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'hospitalName',
                style: { width: 200 },
                placeholder: '输入医院名称检索',
                params: {limit: 10, offset: 1 },
                url: API_URL.hospital.queryHospitalMainList,
                config: { id: 'hospitalMainId', name: 'hospitalMainName'},
            },
            rules: {
                required: true,
            }
        }, 
        {
            name: '中心所在院区',
            key: 'courtyardArea',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'courtyardArea',
                style: { width: 200 },
                placeholder: '输入院区名称检索',
                params: { hospitalMainId },
                disabled: !hospitalMainId ,
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                config: { id: 'hospitalId', name: 'courtyardArea', type: 'courtyardArea' },
            },
        },
        {
            name: '中心所在科室',
            key: 'departmentLocalName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'hospitalDepName',
                style: { width: 200 },
                placeholder: '输入科室名称检索',
                params: {limit: 20, hospitalId: hospitalId?hospitalId:null},
                disabled: !needCourtyardArea ? !hospitalMainId : !courtyardArea,
                url: API_URL.hospital.queryDepWhenAddDoctor,
                config: { id: 'hospitalDepartmentId', name: 'departmentLocalName' },
            },
            rules: {
                required: true,
            },
        }, {
            name: 'PI',
            key: 'piUserName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'userCompellation',
                style: { width: 200 },
                placeholder: '输入医生姓名或手机号检索',
                params: {limit: 20, hospitalId: hospitalId, departmentId, postStatus: 'ON' },
                disabled: !departmentId,
                url: API_URL.hospital.queryDoctorByParams,
                config: { id: 'userId', name: 'userCompellation' },
            },
            suffix: !isEdit && <Button type="primary" loading={loading} style={{marginLeft: 40}} onClick={this.confirm}>添加</Button>,
        });

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    handleDelete = (competingCompanyManifestationId) => {
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.deleteCompeteCompany,
            data: {
                competingCompanyManifestationId,
            },
            dataType: 'json',
            doneResult: res => {
                const { list } = this.state;
                message.success(res.success);
                let idx;
                list.forEach((item, index) => {
                    if (item.competingCompanyManifestationId == competingCompanyManifestationId) {
                        idx = index;
                    }
                });
                if (idx || idx === 0) {
                    list.splice(idx, 1);
                }
                this.setState({ list });
                this.props.loadData();
            },
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { list = [] } = this.state;
        let data = null;
        if (list.length > 0) {
            data = list.map((item) => 
                <div
                    className="item-btn"
                    key={item.competingCompanyManifestationId}
                    style={{ width: '100%', padding: 0, border: 'none', background: '#fff' }}
                >
                    <div
                        style={{
                            maxWidth: 258,
                            display: 'inline-block',
                            padding: '0 6px',
                            background: '#eee',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            verticalAlign: 'top',
                        }}
                        title={`${item.companyName}：${item.hospitalName}/${item.departmentLocalName}${item.piUserName && `/${item.piUserName}`}`}
                    >{item.companyName}：{item.hospitalName}/{item.departmentLocalName}{item.piUserName && `/${item.piUserName}`}</div>
                    <Icon
                        type="close"
                        onClick={() => this.handleDelete(item.competingCompanyManifestationId)}
                        style={{ marginLeft: 10, color: '#F00', fontSize: '16px', cursor: 'pointer' }}
                    />
                </div>   
            )
        }
        return data;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { isEdit, data } = this.state;
        const { 
            competingCompanyManifestationId, 
            competingCompanyId, 
            companyName, 
            hospitalId, 
            hospitalName, 
            departmentId, 
            departmentLocalName, 
            piUserId, 
            piUserName,
            actualStartSiteAmount, 
            actualRandomAmount,
        } = data;
        this.setState({ loading: true });
        const url = isEdit ? API_URL.competeCompany.updateCompeteCompany : API_URL.competeCompany.submitCompeteCompany;
        const options = {
            method: 'POST',
            url,
            data: {
                piUserId,
                hospitalId,
                departmentId,
                competingCompanyId,
                competingCompanyManifestationId,
                actualStartSiteAmount, 
                actualRandomAmount,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                const obj = { loading: false };
                if (isEdit) {
                    obj.visible = false;
                } else {
                    const { list } = this.state;
                    list.push({
                        piUserId,
                        piUserName,
                        hospitalId,
                        companyName,
                        departmentId,
                        hospitalName,
                        competingCompanyId,
                        departmentLocalName,
                        competingCompanyManifestationId: res.competingCompanyManifestationId,
                    });
                    obj.list = list;
                    obj.data = {
                        competingCompanyId,
                    };
                }
                this.setState({ ...obj }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        }
        $.sendRequest(options);
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}竞争公司中心`}
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="550px"
                footer={
                    isEdit
                    ?
                        <div>
                            <Button onClick={this.hide}>取消</Button>
                            <Button type="primary" loading={loading} onClick={this.confirm}>确认</Button>
                        </div>
                    :
                        <Button onClick={this.hide}>关闭</Button>
                }
            >
                <FormList
                    className="form-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
                {
                    !isEdit &&
                    <div
                        className="modal-content"
                        style={{ padding: '10px 0 0', borderTop: '1px solid #d1d1d1' }}
                    >
                        <ul className="modal-list" style={{position: 'relative'}}>
                            <li className="modal-item" style={{ padingLeft: 30 }}>
                                <div className="item-left" style={{width: 126, paddingRight: 10}}>已添竞争公司中心:</div>
                                <div className="item-right">
                                    { this.getDataList() }
                                </div>
                            </li>
                        </ul>
                    </div>
                }
            </Modal>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/competeCompany/Performance/components/Update.js